import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const doctorLocaleModule: LocaleModule = {
  name: "doctor",
  messages: { en: en, it: it },
};
